module.exports = __webpack_public_path__ + "large4.jpg?9ac41de03e2d977151570c764b8a5fef";